import { chatHttp } from "./gateways/chatHttp";
import { ReconnectingEventSource } from "./ReconnectingEventSource";
import type { DoBotResponse, ForDoBotPayload } from "./types/common";
import type { StreamedAnswerData } from "./types/events";

export class StreamedMessagesReceiver {
  private readonly eventSource: ReconnectingEventSource;
  constructor(
    private readonly analyticsId: string,
    callbacks: {
      receivedAnswerChunk: (messageChunk: string) => void;
      receivedFinalMessage: (
        finalPayload: DoBotResponse,
        isInLiveChatMode?: boolean,
        isLiveChatActive?: boolean
      ) => void;
      onError: () => void;
    }
  ) {
    const baseUrl = `api/${this.analyticsId}/events`;
    this.eventSource = new ReconnectingEventSource(baseUrl, {
      onMessage: (data: unknown) => {
        if (typeof data !== "string") {
          // eslint-disable-next-line no-console
          console.error("Received data with non-string type");
          return;
        }
        const payload: StreamedAnswerData = JSON.parse(data); //TODO: zod
        if (!payload.isComplete) {
          callbacks.receivedAnswerChunk(payload.messageChunk);
        } else {
          callbacks.receivedFinalMessage(
            payload.formattedPayload,
            payload.isInLiveChatMode,
            payload.isLiveChatActive
          );
        }
      },
    });
  }

  close() {
    this.eventSource.close();
  }
}

// do-chat resolves the do-bot URL itself, from the conversation.
export async function sendQuestionToDoChat(payload: ForDoBotPayload): Promise<void> {
  const analyticsSessionId = payload.sender;
  await chatHttp.post(`/api/${analyticsSessionId}/send`, payload);
}

export async function sendQuestionToDoBot(payload: ForDoBotPayload): Promise<DoBotResponse> {
  const analyticsSessionId = payload.sender;
  const res = await chatHttp.post<DoBotResponse>(`/api/${analyticsSessionId}/send-direct`, payload);
  return res.data;
}
